import { Box, Typography } from '@mui/material';
import { durationFromSeconds, formatDuration } from '@/modules/common/helpers/date';
import { SimulationGroup } from '@thive/fddm-types';

type Props = {
  simulation: SimulationGroup;
};

export const CompletedDuration = ({ simulation }: Props) => {
  if (!simulation.simulatedDurationInSec || !simulation.totalDurationInSec) {
    return null;
  }

  return (
    <Typography variant='caption' fontSize={10}>
      <Box component='span' color='neutral.darker'>
        {formatDuration(durationFromSeconds(simulation.simulatedDurationInSec))}
      </Box>{' '}
      {`/ ${formatDuration(durationFromSeconds(simulation.totalDurationInSec))}`}
    </Typography>
  );
};
